<div *ngIf="!value" class="tw-flex">
  <p-button label="Set price" icon="pi pi-plus" (click)="value={}"></p-button>
</div>
<div *ngIf="value" class="card" style="background-color: rgba(100, 100, 100, 0.1);">
  <div class="tw-flex">
    <p-button icon="pi pi-trash" (click)="reset()" label="Reset price"></p-button>
  </div>
  <div class="p-fluid p-formgrid grid">
    <div class="field col-6">
      <label htmlFor="type">Discount Type</label>
      <p-listbox [options]="discountTypes" [(ngModel)]="value.DiscountType" (onChange)="changed()" [checkbox]="true"
        [showToggleAll]="false"></p-listbox>
    </div>

    <div class="field col-6">
      <label htmlFor="value">Value</label>
      <input pInputText id="value" type="number" [(ngModel)]="value.Value" (ngModelChange)="changed()" />
    </div>
  </div>

  <div class="tw-mt-2">
    <p-checkbox binary="true" label="Different price per order type (Delivery / Pickup / Eat in)"
      [ngModel]="hasPerTypePrices" (ngModelChange)="togglePerTypePrices($event)"></p-checkbox>
  </div>

  @if(hasPerTypePrices) {
  <div class="p-fluid p-formgrid grid tw-mt-2">
    <div class="field col-12 md:col-4">
      <label htmlFor="delivery-value">Delivery</label>
      <input pInputText id="delivery-value" type="number" placeholder="Default value"
        [(ngModel)]="value.DeliveryValue" (ngModelChange)="changed()" />
    </div>
    <div class="field col-12 md:col-4">
      <label htmlFor="pickup-value">Pick up</label>
      <input pInputText id="pickup-value" type="number" placeholder="Default value"
        [(ngModel)]="value.PickupValue" (ngModelChange)="changed()" />
    </div>
    <div class="field col-12 md:col-4">
      <label htmlFor="dinein-value">Eat in</label>
      <input pInputText id="dinein-value" type="number" placeholder="Default value"
        [(ngModel)]="value.DineInValue" (ngModelChange)="changed()" />
    </div>
    <small class="col-12 tw-text-gray-500">Leave a field empty to fall back to the shared Value above for that
      order type.</small>
  </div>
  }
</div>